import { Grid } from '@material-ui/core';
import * as React from 'react';
import './InnovationDashboard.css';
import { Phase } from './phase';
import { useQuery } from 'react-query';
import { Alert } from '@material-ui/lab';

export const InnovationDashBoard: React.FC<InnovationDashBoardProps> = (props: InnovationDashBoardProps) => {

    // const bwGroup = _PortalState.groups.find(g => g.GroupId === props.groupid);

    const { isLoading, error, data } = useQuery('phases', () =>
        fetch('/phases.json').then(r => r.json())
    );


    // var data = {
    //     labels: [1, 2, 3, 4, 5, 6, 7, 8],
    //     series: [
    //         [5, 9, 7, 8, 5, 3, 5, 4]
    //     ]
    // };

    // var options = {
    //     low: 0,
    //     showArea: true
    // };



    // const rows: any[] = [
    //     // { name: "Experiment 1: The Search", interviewCount: 5, Validated: 0 },
    //     // { name: "Experiment 2: The Find", interviewCount: 5, Validated: 1 },
    //     // { name: "Experiment 1: The Loss", interviewCount: 5, Validated: 2 }
    // ];

    if (isLoading) return (<div></div>)

    return (
        <Grid container direction="row" justify="flex-start" spacing={3}>



            {/* <Grid item xs={12} md={12} lg={12}>
                <Card >
                    <CardContent>
                    <Typography variant="h6" component="h2" gutterBottom>
                            Statistics
                            <br/>
                    </Typography>
                        <ChartistGraph data={data} options={options} type={'Line'} />
                    </CardContent>
                </Card>
            </Grid> */}

            <Grid item xs={12} md={12} lg={12} >
                <Alert severity="info">For support on any of your experiment or stage updates, please contact your BW Ventures consultant via Teams or send an email to support@bwventures.nl.</Alert>
                
            </Grid>

            {data.map((p: any) => {
                return (
                    <Grid key={p.Id} item xs={12} md={12} lg={12}>
                        <Phase phase={p} />
                    </Grid>
                )
            })}

        </Grid >
    )


}

interface InnovationDashBoardProps {
    groupid: string;
}


interface phaseProblemDiscovery {

}

interface phaseSolutionDiscovery {

}

interface phasePitchMVP {

}

interface phaseMiscExperiment {

}